// --- External Libraries
import moment from 'moment-timezone';
// --- Components
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';

export const id = {
    field: 'id',
    headerName: 'ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'jobMetrics',
    }
};

export const jobType = {
    field: 'jobType',
    headerName: 'Job Type',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'jobType',
        page: 'jobMetrics',
    }
};

export const jobRuns = {
    field: 'totalJobRuns',
    headerName: 'Total Job Runs',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'totalJobRuns',
        page: 'jobMetrics',
    }
};

export const targetCount = {
    field: 'totalTargetCount',
    headerName: 'Total Target Count',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'totalTargetCount',
        page: 'jobMetrics',
    }
};

export const totalMinutesToComplete = {
    field: 'totalSecondsToComplete',
    headerName: 'Total Minutes to Complete',
    valueFormatter: ({ value }) => value ? (value / 60).toFixed(2) : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'totalSecondsToComplete',
        page: 'jobMetrics',
    }
};

export const maxMinutesToComplete = {
    field: 'maxSecondsToComplete',
    headerName: 'Max Minutes to Complete',
    valueFormatter: ({ value }) => value ? (value / 60).toFixed(2) : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'maxSecondsToComplete',
        page: 'jobMetrics',
    }
};

export const avgMinutesToComplete = {
    field: 'averageSecondsToComplete',
    headerName: 'Average Minutes to Complete',
    valueFormatter: ({ value }) => value ? (value / 60).toFixed(2) : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'averageSecondsToComplete',
        page: 'jobMetrics',
    }
};

export const avgSecondsPerTarget = {
    field: 'averageSecondsPerTarget',
    headerName: 'Average Seconds per Target',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'averageSecondsPerTarget',
        page: 'jobMetrics',
    }
};

export const errorRate = {
    field: 'errorRate',
    headerName: 'Error Rate',
    valueFormatter: ({ value }) => value !== undefined && value !== null ? `${(value * 100).toFixed(2)}%` : '',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'errorRate',
        page: 'jobMetrics',
    }
};

export const createdAt = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(value).tz(moment.tz.guess()).format('MMM-DD-YYYY, h:mm:ss A z') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'jobMetrics',
    }
};
